export default {
    state: {
        url: '/api/hms/signatures/archived',
        signatures: [],
        errors: {},
        meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'id',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'date', label: 'Date', sortable: true, tdClass: 'text-muted'},
                {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                {key: 'address', label: 'Address', tdClass: 'text-muted'},
                {key: 'total', label: 'Occupied Units', tdClass: 'text-muted'},
                {key: 'signed', label: 'Signs Received', tdClass: 'text-muted'},
                {key: 'sign_percentage', label: '% of Signs', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
    },

    getters: {
        getSignatureArchived: state => state.signature,

        getSignatureArchivedTableFields: state => state.table.fields,

        getSignaturesArchivedMeta: state => state.meta,

        getSignatureArchivedErrors: state => state.errors,
    },

    mutations: {
        setSignaturesArchived: (state, payload) => {
            state.signatures = payload;
        },

        setSignature: (state, payload) => {
            state.signature_id = payload.signature_id;
            state.signature = payload;
        },

        setSignaturesArchivedMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setSignatureArchivedErrors: (state, payload) => {
            state.errors = payload;
        },

        resetSignaturesArchivedMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'id',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },
    },

    actions: {
        fetchSignaturesArchived: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };

            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url+'?state', {params: parameters})
                    .then(response => {
                        commit('setSignaturesArchived', response.data);

                        commit('setSignaturesArchivedMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('setSignatureArchivedErrors', error.response.data.errors);

                        reject(error);
                    });
            });
        },
    }
}
